import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, catchError, Observable, retry, take, tap, throwError } from 'rxjs';
import { AppInterface } from '../../interfaces/app.interface';
import { AppDetailsService } from './app-details.service';
import { ErrorSignalService } from '../../components/error-page/services/error-signal.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AppDetailsApiService {
  baseUrl = environment.baseUrl;
  appDetailsUrl = `${this.baseUrl}/apps`;
  appDetails!: BehaviorSubject<AppInterface>;

  constructor(
    public appDetailsService: AppDetailsService,
    private http: HttpClient,
    private errorSignalService: ErrorSignalService,
    private router: Router,
  ) {}

  getAppDetails(id: number, cached: boolean = false, canonicalOnly: boolean = false): Observable<AppInterface> {
    const url = `${this.appDetailsUrl}/${id}?cached=${cached}&canonicalOnly=${canonicalOnly}`;
    return this.http.get<AppInterface>(url).pipe(
      take(1),
      tap((appDetails) => this.appDetailsService.setCurrentAppDetails(appDetails)),
      retry(3), // retry transient failures
      catchError((error) => {
        console.error('AppDetails API failed after retries:', error);

        if (error.status === 404) {
          // Redirect to a not-found route
          this.router.navigate(['error/404']);
        } else if (error.status === 401) {
          // for 401 do nothing - sso will fix it automatically
        } else {
          // Trigger App Details banner for other errors
          this.errorSignalService.triggerAppDetailsBanner();
        }

        return throwError(
          () => new Error('Sorry, we couldn’t load the app details. Please try again later.'),
        );
      }),
    );
  }
}
